import { convertDateToString2 } from 'constants/helper';

export function cleanMatch(groupMatch) {
  groupMatch = groupMatch.trim();
  groupMatch = groupMatch.replace('{{', '');
  groupMatch = groupMatch.replace('}}', '');
  return groupMatch;
}
// if prefix like + is not present, empty string would be returned
export function getPrefixAndClassName(groupMatch) {
  let firstChar = '';
  // if first char is not { that means a prefix is present or it's a customDateDisplay macro. eg. ` {{customDateDisplay.29347982347892}}`
  if (groupMatch[0] !== '{') {
    firstChar = groupMatch[0];
    groupMatch = groupMatch.replace(firstChar, '');
  }
  let className;
  switch (firstChar) {
    case '#':
      className = 'strengthTag';
      break;
    case '@':
      className = 'mentionComponent';
      break;
    case '+':
      className = 'meshMoney';
      break;
    default:
      if (groupMatch.includes('customDateDisplay')) {
        className = 'customDateDisplayTag';
      } else if (groupMatch.includes('demographics.TASK')) {
        className = 'demographicsTaskDetailsTag';
      } else {
        className = '';
      }
  }
  return { prefix: firstChar, className };
}

export function isEmployeeTag(tagType) {
  return tagType === 'employees';
}

export function isDemographicsTag(tagType) {
  return tagType === 'demographics';
}

export function isCustomDateDisplayTag(tagType) {
  return tagType === 'customDateDisplay';
}

// removing prefix like +,@,#
export function cleanKey(key) {
  return key.replace(/[+,@,#]/gm, '');
}

export function getPrefixAndContent({ res, groupMatch }) {
  try {
    let { prefix, className } = getPrefixAndClassName(groupMatch);
    const cleanedMatch = cleanMatch(groupMatch);
    const keys = cleanedMatch.split('.');
    // this response will contain an object from which
    // we can get data using our keys
    let d = { ...res };
    const tagType = cleanKey(keys[0]);
    /* on post header, there was no @ tag, but we still need employee tagging there
      distinguishing the classNames because in postHeader it doesn't make sens to make it a mention component
     */
    if (tagType === 'employees' && className !== 'mentionComponent') className = 'employeeTag';
    let data;

    // we need to know if it was an employee and need employee data so that we can
    // go to that employee's profile page
    if (isEmployeeTag(tagType)) {
      data = { ...res[tagType][cleanKey(keys[1])] };
    } else if (isDemographicsTag(tagType)) {
      if (className === 'demographicsTaskDetailsTag') {
        data = res[tagType][keys[1]][keys[2]][keys[3]];
      } else {
        data = { ...res[tagType][cleanKey(keys[1]).toUpperCase()][cleanKey(keys[2])] };
      }
    } else if (isCustomDateDisplayTag(tagType)) {
      const date = new Date(parseInt(keys[1]));
      data = convertDateToString2(date);
    }
    if (className === 'strengthTag') {
      data = { ...res.attributes.orgTag[cleanKey(keys[2])] };
    }
    // drill into response using the keys that we have
    // the result will be the final content
    for (let i = 0; i < keys.length && d; i++) {
      d = d[cleanKey(keys[i])];
    }
    return {
      prefix,
      content: d,
      contentKeys: keys,
      className,
      data,
      tagType,
    };
  } catch (err) {
    // TODO: throw sentry exception
    return {
      content: groupMatch,
      className: '',
      prefix: '',
    };
  }
}
